<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tp01">
<a id="page03">
<h2 class="titlePageAuthor"><span class="bold"><em class="italic">Jennie Lucas</em></span></h2>
<h2 class="titlePageTitle"><span class="bold">BOUGHT: THE GREEK’S BABY</span></h2>
<p class="titlePageLogo"><img alt="image" src="Images/logo.jpg"/></p>
</a></div>
<a id="page03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// boughtthegreeksbaby_tp01.vue?ce5a20e2